import * as THREE from 'three';

export class FikoVektor2D extends THREE.Vector2 {

    constructor(x?: number, y?: number) {
        super(x, y);
    }

    aci?(p2: FikoVektor2D = null) {
        if (!p2) {
            return this.angle() * (180 / Math.PI);
        } else {
            var dy = this.y - p2.y;
            var dx = this.x - p2.x;
            var theta = Math.atan2(dy, dx); // range (-PI, PI]
            theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
            return theta;
        }
    }

    tasi?(mesafe: number) {
        mesafe = typeof mesafe !== 'undefined' ? mesafe : 0;
        let angle = this.angle();
        return new FikoVektor2D(mesafe * Math.cos(angle) + this.x, mesafe * Math.sin(angle) + this.y)
    }

    offsetToScale?(offset: number) {
        const xSign = Math.sign(this.x)
        const ySign = Math.sign(this.y)
        const xOffsetli = (Math.abs(this.x) + offset);
        const yOffsetli = (Math.abs(this.y) + offset);

        return new FikoVektor2D((this.x * (xOffsetli / this.x)) * xSign, (this.y * (yOffsetli / this.y)) * ySign)
    }

    aci360?(ex: number, ey: number) {
        var theta = this.aci(new FikoVektor2D(ex, ey)); // range (-180, 180]
        if (theta < 0) theta = 360 + theta; // range [0, 360)
        return theta;
    }
}